<app-auth-navbar></app-auth-navbar>
<div class="container">
    <div class="row">
        <div class="col-lg-4 col-md-6 col-12 mx-auto" style="margin-top: 100px;">
            <div class="d-flex justify-content-center flex-wrap w-100 py-3" *ngIf="offer?.status" >
                <div class="col-12 px-3 text-center py-2 offer" style="background-color: #A0BF81;" [innerHTML]="offer.subject">
                </div>
                <div class="col-10 px-3 text-center mt-2 py-2 offer" style="background-color: #266DD3;" [innerHTML]="offer.message">
                </div>
            </div>
            <form #registerForm="ngForm" (ngSubmit)="onRegisterFromSubmit(registerForm)">
                <h3 class="signin_heading custom-heading text-center">Continue with</h3>
                <br>
                <div class="d-flex justify-content-center align-items-center flex-wrap">
                    <div *ngIf="firebase.showAppleSignIn" class="col-12 text-center cursor-pointer my-1" (click)="firebase.openAppleSignIn()">
                        <button class="loginBtn loginBtn--apple">
                            Signup with Apple
                          </button>
                    </div>
                    <div class="col-12 text-center cursor-pointer my-1" (click)="firebase.signInWithGoogle()">
                        <div class="loginBtn loginBtn--google cursor-pointer d-flex align-items-center">
                            Signup with Google
                        </div>
                    </div>
                    <!-- <div class="col-12 text-center cursor-pointer my-1" (click)="firebase.signInWithFacebook()">
                        <div class="loginBtn loginBtn--facebook cursor-pointer d-flex align-items-center">
                            Signup with Facebook
                        </div>
                    </div> -->
                    
                </div>
                <br>
                <div class="text-center mt-4 mb-0" style="line-height: 7px;">
                    <p class="signin__text">By Signing up, you are agreeing to our</p>
                    <a routerLink="/terms-and-conditions" class="terms">Terms & Conditions</a>
                </div>
                <div class="text-center my-5 mt-2">
                    <span class="signin__text">Already have an account?</span> <span>
                        <a routerLink="/signin" class="terms"> Sign in</a>
                    </span>
                </div>
                
            </form>
           
        </div>
    </div>
</div>